var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F7F9FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7.33341C4 6.96522 4.29848 6.66675 4.66667 6.66675H19.3333C19.7015 6.66675 20 6.96522 20 7.33341C20 7.7016 19.7015 8.00008 19.3333 8.00008H4.66667C4.29848 8.00008 4 7.7016 4 7.33341ZM4 12.0001C4 11.6319 4.29848 11.3334 4.66667 11.3334H19.3333C19.7015 11.3334 20 11.6319 20 12.0001C20 12.3683 19.7015 12.6667 19.3333 12.6667H4.66667C4.29848 12.6667 4 12.3683 4 12.0001ZM4 16.6667C4 16.2986 4.29848 16.0001 4.66667 16.0001H19.3333C19.7015 16.0001 20 16.2986 20 16.6667C20 17.0349 19.7015 17.3334 19.3333 17.3334H4.66667C4.29848 17.3334 4 17.0349 4 16.6667Z",
    fill: "#576473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/Drag.3d918ef748c637d050bb80d326a13d1a.svg";
export { ForwardRef as ReactComponent };